import {useCallback} from 'react';
import {useQueryClient} from '@tanstack/react-query';
import {API, GuestTokenStorageHandler} from '@chekin/api';
import {QUERY_CACHE_KEYS} from '@chekin/core';
import {useFetchUser} from './useFetchUser';
import {removeIVIntentRemoteSession} from 'hooks/iv/useIVRemoteSync';

function useAuth() {
  const queryClient = useQueryClient();
  const {
    data: user,
    refetch,
    isLoading,
    isError,
    error,
    isInitialLoading,
  } = useFetchUser();
  const isLoggedIn = Boolean(user?.id && GuestTokenStorageHandler.hasToken());

  const logout = useCallback(() => {
    GuestTokenStorageHandler.removeToken();
    removeIVIntentRemoteSession();
    queryClient.setQueryData([QUERY_CACHE_KEYS.user], null);
    queryClient.setQueryData([QUERY_CACHE_KEYS.participants], null);
  }, [queryClient]);

  const authenticate = useCallback(
    ({token}: {token: string}) => {
      GuestTokenStorageHandler.persistToken(token);
      API.setJwtToken(token);
      void refetch();
    },
    [refetch],
  );

  return {
    logout,
    isLoggedIn,
    isLoading,
    isError,
    error,
    user,
    authenticate,
    isInitialLoading,
  };
}

export {useAuth};
